var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isActive)?_c('div',{staticClass:"progress-modal"},[_c('div',{staticClass:"progress"})]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }